import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faBrowser,
  faCircleHeart,
  faEnvelopeOpenText,
  faEnvelopesBulk,
  faFilePdf,
  faGlobePointer,
  faHeart,
  faHouse,
  faHouseBuilding,
  faHouseFlag,
  faHouseHeart,
  faKey,
  faLocationArrowUp,
  faLocationCrosshairs,
  faMailbox,
  faMoneyBill,
  faPaperPlane,
  faPhoneRotary,
  faPhoneVolume,
  faSquareHeart,
  faStarSharp,
} from '@awesome.me/kit-644ec404bf/icons/classic/regular';
import {
  faHouseLettingsPerson,
  faHouseSalesPerson,
  faLettingsSignage,
  faRegularBoltCircleCheck,
  faSalesSignage,
} from '@awesome.me/kit-644ec404bf/icons/kit/custom';
import { faLocationDot } from '@awesome.me/kit-644ec404bf/icons/classic/solid';
import { faPhone } from '@awesome.me/kit-644ec404bf/icons/sharp/regular';
import { faMagnifyingGlass, faThumbsUp } from '@awesome.me/kit-644ec404bf/icons/classic/light';
import SectionIcon = App.Enums.LinkGroup.SectionIcon;

const useLinkGroupSectionIcons = new Map<SectionIcon, IconDefinition>([
  ['house', faHouse],
  ['house_flag', faHouseFlag],
  ['house_heart', faHouseHeart],
  ['house_building', faHouseBuilding],
  ['key', faKey],
  ['money_bill', faMoneyBill],
  ['house_lettings_person', faHouseLettingsPerson],
  ['house_sales_person', faHouseSalesPerson],
  ['sales_signage', faSalesSignage],
  ['lettings_signage', faLettingsSignage],
  ['bolt_circle_check', faRegularBoltCircleCheck],
  ['mailbox', faMailbox],
  ['paper_plane', faPaperPlane],
  ['envelope_open_text', faEnvelopeOpenText],
  ['envelopes_bulk', faEnvelopesBulk],
  ['location_dot', faLocationDot],
  ['location_crosshairs', faLocationCrosshairs],
  ['location_arrow_up', faLocationArrowUp],
  ['phone', faPhone],
  ['phone_rotary', faPhoneRotary],
  ['phone_volume', faPhoneVolume],
  ['globe_pointer', faGlobePointer],
  ['browser', faBrowser],
  ['star_sharp', faStarSharp],
  ['thumbs_up', faThumbsUp],
  ['magnifying_glass', faMagnifyingGlass],
  ['file_pdf', faFilePdf],
  ['heart', faHeart],
  ['square_heart', faSquareHeart],
  ['circle_heart', faCircleHeart],
]);

export default useLinkGroupSectionIcons;
